var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 13.125H35.625C37.6969 13.125 39.375 14.8031 39.375 16.875V33.75C39.375 35.8219 37.6969 37.5 35.625 37.5H9.375C7.30312 37.5 5.625 35.8219 5.625 33.75V16.875C5.625 14.8031 7.30312 13.125 9.375 13.125Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.125L28.98 10.065C28.47 8.53313 27.0356 7.5 25.4212 7.5H19.5769C17.9644 7.5 16.53 8.53313 16.02 10.065L15 13.125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.81 20.625C26.7938 20.625 28.125 22.3706 28.125 23.9963C28.125 27.2981 22.6013 30 22.5 30C22.3987 30 16.875 27.2981 16.875 23.9963C16.875 22.3706 18.2062 20.625 20.19 20.625C21.3244 20.625 22.0687 21.1556 22.5 21.6281C22.9313 21.1556 23.6756 20.625 24.81 20.625Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.916 16.875C33.5704 18 34.5004 18.93 35.6254 19.5844",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0844 33.7499C11.43 32.6249 10.5 31.6949 9.375 31.0405",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0844 16.875C11.43 18 10.5 18.93 9.375 19.5844",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6254 31.0405C34.5004 31.6949 33.5704 32.6249 32.916 33.7499",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSuitcase);
export default __webpack_public_path__ + "static/media/navigation-suitcase.226a2e44.svg";
export { ForwardRef as ReactComponent };